import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Validator from 'validatorjs';
import _, { isEmpty } from 'lodash';
import {
  Form,
  Button,
  Modal,
  Header,
  Icon,
  Input,
  Confirm,
  Checkbox,
  Select,
  Message,
} from 'semantic-ui-react';
import { utcMoment } from '../../utilities/dateUtils';
import cancelEnrollmentMutation from '../../graphql/cancelEnrollmentMutation';
import modifyEnrollmentMutation from '../../graphql/modifyEnrollmentMutation';
import newEnrollmentMutation from '../../graphql/createNewEnrollmentMutation';

class ReviewForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successfulCompletion: false,
      message: '',
      endDate: '',
      errors: {},
      unsuccessfulCompletion: '',
    };
  }

  onDateChangeHandler = field => newDate => {
    this.setState({ [field]: moment(newDate, 'YYYY-MM-DD') });
  };

  render() {
    const {
      dealerNumber,
      dealername,
      contactname,
      contactemail,
      contactphone,
      product1,
      product2,
      cascade,
      purchaseChannel1,
      location1,
      location2,
      psimileage1,
      lpiprice1,
      psiprice1,
      startDate1,
      startDate2,
      endDate1,
      endDate2,
      onCloseHandler,
      redirectToAutoPsiTab,
      modify,
      cancel,
      createNewEnrollment,
      excludeCloseSale,
      productOptions,
      product2Options,
      totalLocations,
      cancelForm,
      modifyCloseHandler,
      mutateCancelEnrollment,
      mutateModifyEnrollment,
      mutateNewEnrollment,
    } = this.props;

    const {
      errors,
      successfulCompletion,
      message,
      unsuccessfulCompletion,
      endDate: endDateState,
    } = this.state;

    const validationRules = {
      endDate: 'required',
    };

    const cascadeLpiLabels = ['Yes', 'No'];
    const factoryLpiLabels = ['True', 'False'];

    const date = isEmpty(startDate1)
      ? null
      : utcMoment(startDate1).format('YYYY-MM-DD');

    const productNames = {
      sevenDayVarPSI: 'Auto PSI 7 Day',
      fourteenDayVarPSI: 'Auto PSI 14 Day',
      sevenDayFlatPSI: 'Flat Rate Auto PSI 7 Day',
      fourteenDayFlatPSI: 'Flat Rate Auto PSI 14 Day',
    };

    const productList = isEmpty(product2)
      ? product1
      : `${productNames[product1]} , ${productNames[product2]}`;

    const dateList = isEmpty(product2)
      ? startDate1
      : `${startDate1} , ${utcMoment(startDate2).format('YYYY-MM-DD')}`;

    const productHashWithPrice = {
      [product1]: {
        auctionIds: location1,
        startDate: isEmpty(startDate1)
          ? null
          : utcMoment(startDate1).format('YYYY-MM-DD'),
        endDate: isEmpty(endDate1)
          ? null
          : utcMoment(endDate1).format('YYYY-MM-DD'),
        PSIprice: `${psiprice1}`,
        mileage: `${psimileage1 || 0}`,
        LPIprice: `${lpiprice1}`,
        channel: purchaseChannel1,
      },
      [product2]: {
        auctionIds: location2,
        startDate: isEmpty(startDate2)
          ? null
          : utcMoment(startDate2).format('YYYY-MM-DD'),
        endDate: isEmpty(endDate2)
          ? null
          : utcMoment(endDate2).format('YYYY-MM-DD'),
        PSIprice: `${psiprice1}`,
        mileage: `${psimileage1 || 0}`,
        LPIprice: `${lpiprice1}`,
        channel: purchaseChannel1,
      },
    };

    const productHashWithoutPrice = {
      [product1]: {
        auctionIds: location1,
        startDate: isEmpty(startDate1)
          ? null
          : utcMoment(startDate1).format('YYYY-MM-DD'),
        endDate: isEmpty(endDate1)
          ? null
          : utcMoment(endDate1).format('YYYY-MM-DD'),
        mileage: `${psimileage1 || 0}`,
        channel: purchaseChannel1,
      },
      [product2]: {
        auctionIds: location2,
        startDate: isEmpty(startDate2)
          ? null
          : utcMoment(startDate2).format('YYYY-MM-DD'),
        endDate: isEmpty(endDate2)
          ? null
          : utcMoment(endDate2).format('YYYY-MM-DD'),
        mileage: `${psimileage1 || 0}`,
        channel: purchaseChannel1,
      },
    };

    const productHash = product1 === 'sevenDayFlatPSI' || product1 === 'fourteenDayFlatPSI'
      ? productHashWithPrice
      : productHashWithoutPrice;

    const payload = {
      subscription: {
        dealerNumber: `${dealerNumber}`,
        dealerName: dealername,
        contactName: contactname,
        contactEmail: contactemail,
        contactPhoneNumber: contactphone,
        cascade,
        excludeCloseSale,
        products: _.omit(productHash, 'null'),
      },
    };

    const submitForm = () => {
      if (cancel) {
        const validation = new Validator(this.state, validationRules);
        if (validation.fails()) {
          this.setState(prevState => ({ ...prevState, ...validation.errors }));
          return false;
        }
        const cancelEnrollmentInput = {
          subscription: {
            dealerNumber: `${dealerNumber}`,
            endDate: endDateState.format('YYYY-MM-DD'),
          },
        };

        mutateCancelEnrollment({
          variables: { cancelEnrollmentInput },
        }).then(({ data: { cancelSubscription } }) => {
          const { success, errors: cancelErrors } = cancelSubscription;
          if (success) {
            this.setState(prevState => ({
              successfulCompletion: true,
              message: `Thank you. Dealer ${dealerNumber} has successfully cancelled enrollment. 
                            Cancellation effective ${prevState.endDate.format('MM/DD/YYYY')}`,
            }));
          } else {
            this.setState({ unsuccessfulCompletion: cancelErrors[0] });
          }
        });
        this.setState(prevState => ({ ...prevState, ...validation.errors }));
      } else if (modify) {
        const modifyEnrollmentInput = payload;

        mutateModifyEnrollment({
          variables: { modifyEnrollmentInput },
        }).then(({ data: { updateSubscription } }) => {
          const { success, errors: modifyErrors } = updateSubscription;
          if (success) {
            this.setState({
              successfulCompletion: true,
              message: `Dealer ${dealerNumber} has successfully modified enrollment. 
                          New changes will begin for ${productList} on ${dateList} respectively`,
            });
          } else {
            this.setState({ unsuccessfulCompletion: modifyErrors[0] });
          }
        });
      } else if (createNewEnrollment) {
        const newEnrollmentInput = payload;

        mutateNewEnrollment({
          variables: { newEnrollmentInput },
        }).then(({ data: { newSubscription } }) => {
          const { success, errors: newErrors } = newSubscription;
          if (success) {
            this.setState({
              successfulCompletion: true,
              message: `Dealer ${dealerNumber} has successfully enrolled in ${productList} with coverage 
                            beginning  ${date}`,
            });
          } else {
            this.setState({ unsuccessfulCompletion: newErrors[0] });
          }
        });
      }
      return true;
    };

    const handleConfirm = () => {
      this.setState({
        successfulCompletion: false,
      });
      modifyCloseHandler();
      cancelForm();
      redirectToAutoPsiTab();
    };

    const endDate = isEmpty(endDateState)
      ? null
      : utcMoment(endDateState);

    return (
      <Modal
        open
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        {successfulCompletion && (
          <Confirm
            className='confirm-form'
            open
            content={message}
            onConfirm={handleConfirm}
          />
        )}
        {unsuccessfulCompletion && (
          <Message negative>
            <p>Received error: {unsuccessfulCompletion}</p>
          </Message>
        )}
        {modify && (
          <Modal.Header>
            Please review your enrollment selections:
          </Modal.Header>
        )}
        {cancel && (
          <Modal.Header>
            Are you sure that you want to cancel the following enrollment?
          </Modal.Header>
        )}
        {createNewEnrollment && (
          <Modal.Header>
            Please review your enrollment selections:
            <br />
            If you want to make changes, please press cancel to return to enrollment form
          </Modal.Header>
        )}
        <Modal.Content image>
          <Modal.Description>
            <Form>
              <Header size='small' color='blue' />
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='dealerNumber'>Dealer #</label>
                  <Input
                    id='dealerNumber'
                    name='dealerNumber'
                    value={dealerNumber}
                    disabled
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='dealername'>Dealership Name</label>
                  <Input id='dealername' name='dealername' value={dealername} disabled />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='contactname'>Contact Name</label>
                  <Input
                    id='contactname'
                    name='contactname'
                    value={contactname}
                    disabled
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='contactemail'>Contact Email</label>
                  <Input
                    id='contactemail'
                    name='contactemail'
                    value={contactemail}
                    disabled
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='contactphone'>Contact Phone # </label>
                  <Input
                    id='contactphone'
                    name='contactphone'
                    value={contactphone}
                    disabled
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='product1'>Product 1</label>
                  <Select
                    id='product1'
                    options={productOptions}
                    name='product1'
                    value={product1}
                    className='product-type-selector'
                    disabled
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='location1'>Auction Location 1</label>
                  <Select
                    id='location1'
                    options={totalLocations}
                    name='location1'
                    value={location1}
                    multiple
                    selection
                    disabled
                  />
                </Form.Field>
              </Form.Group>
              {product2 && (
                <Form.Group widths='equal'>
                  <Form.Field>
                    <label htmlFor='product2'>Product 2</label>
                    <Select
                      id='product2'
                      options={product2Options}
                      name='product2'
                      value={product2}
                      className='product-type-selector'
                      disabled
                    />
                  </Form.Field>
                </Form.Group>
              )}
              {product2 && (
                <Form.Group widths='equal'>
                  <Form.Field>
                    <label htmlFor='location2'>Auction Location 2</label>
                    <Select
                      id='location2'
                      options={totalLocations}
                      name='location2'
                      value={location2}
                      multiple
                      selection
                      disabled
                    />
                  </Form.Field>
                </Form.Group>
              )}
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='cascade-0'>Cascade to LPI </label>
                  {[{ Yes: 'true' }, { No: 'false' }].map(
                    (cascadeValue, index) => (
                      <Checkbox
                        id={`cascade-${index}`}
                        key={cascadeLpiLabels[index]}
                        radio
                        label={cascadeLpiLabels[index]}
                        checked={
                          cascade.toString()
                          === cascadeValue[cascadeLpiLabels[index]]
                        }
                        disabled
                      />
                    )
                  )}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='factory-0'>Exclude Factory </label>
                  {[{ True: 'true' }, { False: 'false' }].map(
                    (factoryValue, index) => (
                      <Checkbox
                        id={`factory-${index}`}
                        key={factoryLpiLabels[index]}
                        radio
                        label={factoryLpiLabels[index]}
                        checked={
                          excludeCloseSale.toString()
                          === factoryValue[factoryLpiLabels[index]]
                        }
                        disabled
                      />
                    )
                  )}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='channel-In-Lane'>Purchase Channel Preference </label>
                  {['In-Lane', 'Simulcast'].map(channel => (
                    <Checkbox
                      id={`channel-${channel}`}
                      key={channel}
                      radio
                      label={channel}
                      checked={purchaseChannel1.some(
                        channelName => channelName === channel
                      )}
                      disabled
                    />
                  ))}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='psimileage1'>PSI Mileage </label>
                  <Input id='psimileage1' name='miles' value={psimileage1} disabled />
                </Form.Field>
              </Form.Group>
              {(product1 === 'sevenDayFlatPSI'
                || product1 === 'fourteenDayFlatPSI') && (
                <p>
                  <Form.Group widths='equal'>
                    <Form.Field>
                      <label htmlFor='psiprice1'>PSI Price </label>
                      <Input
                        id='psiprice1'
                        name='miles'
                        value={psiprice1 === undefined ? 0 : psiprice1}
                        disabled
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Form.Field>
                      <label htmlFor='lpiprice1'>LPI Price </label>
                      <Input id='lpiprice1' name='miles' value={lpiprice1} disabled />
                    </Form.Field>
                  </Form.Group>
                </p>
              )}
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='startDate'>AutoPSI Start Date </label>
                  <Input id='startDate' name='startDate' value={date} disabled />
                </Form.Field>
              </Form.Group>
              {cancel && (
                <Form.Group widths='equal'>
                  <Form.Field required error={!isEmpty(errors.endDate)}>
                    <label htmlFor='endDate'>Select AutoPSI End Date </label>
                    <DatePicker
                      id='endDate'
                      style={{ padding: '0', width: '100%' }}
                      selected={endDate}
                      minDate={new Date()}
                      onChange={this.onDateChangeHandler('endDate')}
                      dateFormat='YYYY-MM-DD'
                    />
                    {errors.endDate && <span>{errors.endDate}</span>}
                  </Form.Field>
                </Form.Group>
              )}
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button color='green' onClick={submitForm} inverted>
            <Icon name='checkmark' /> Submit
          </Button>
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

ReviewForm.propTypes = {
  dealerNumber: PropTypes.string,
  dealername: PropTypes.string,
  contactname: PropTypes.string,
  contactemail: PropTypes.string,
  contactphone: PropTypes.string,
  product1: PropTypes.string,
  product2: PropTypes.string,
  cascade: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  purchaseChannel1: PropTypes.array,
  location1: PropTypes.array,
  location2: PropTypes.array,
  psimileage1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lpiprice1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  psiprice1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  startDate1: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  startDate2: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  endDate1: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  endDate2: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onCloseHandler: PropTypes.func,
  redirectToAutoPsiTab: PropTypes.func,
  modify: PropTypes.bool,
  cancel: PropTypes.bool,
  createNewEnrollment: PropTypes.bool,
  excludeCloseSale: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  productOptions: PropTypes.array,
  product2Options: PropTypes.array,
  totalLocations: PropTypes.array,
  cancelForm: PropTypes.func,
  modifyCloseHandler: PropTypes.func,
  mutateCancelEnrollment: PropTypes.func,
  mutateModifyEnrollment: PropTypes.func,
  mutateNewEnrollment: PropTypes.func,
};

const cancelMutation = graphql(cancelEnrollmentMutation, {
  name: 'mutateCancelEnrollment',
});

const modifyMutation = graphql(modifyEnrollmentMutation, {
  name: 'mutateModifyEnrollment',
});

const newMutation = graphql(newEnrollmentMutation, {
  name: 'mutateNewEnrollment',
});

export default compose(
  cancelMutation,
  modifyMutation,
  newMutation
)(ReviewForm);
